import "./GameTabBar.css"

/* The phone's chrome, and the reason the phone layout is not just the desktop one squeezed.

   A round has two moments: giving orders, which needs the map, and reading what happened, which
   does not need it at all. A desktop shows both at once because it has the width to. A phone
   alternates, so what it needs is not smaller docks but a fast way to switch — which is this.

   `value` is the open sheet, or null for the bare map. Pressing the open tab again closes it, so
   the map is always one press away from anywhere.

   END TURN is not a tab. It ends the round, it is pressed every sixty seconds, and bottom-right is
   the one place a thumb reaches without regripping — so it sits here as a slot the caller fills
   (with RoundHandler, which also runs the auto-advance effects and must stay mounted) rather than
   in the top bar, where a phone's thumb does not go. */

const GameTabBar = ({ tabs, value, onChange, children, ariaLabel }) => (
  <nav className="game-tab-bar" aria-label={ariaLabel}>
    <div className="tab-bar-tabs" role="tablist">
      {tabs.map((tab) => {
        const selected = tab.id === value
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            data-tab={tab.id}
            aria-selected={selected}
            className={`tab-bar-button ${selected ? "selected" : ""}`}
            onClick={() => onChange(selected ? null : tab.id)}
          >
            {tab.icon}
            <span className="tab-bar-label">{tab.label}</span>
            {tab.badge != null && (
              <span className={`tab-bar-badge ${tab.badgeTone === "amber" ? "amber" : ""}`}>{tab.badge}</span>
            )}
            {tab.dot && <span className="tab-bar-dot" aria-hidden="true" />}
          </button>
        )
      })}
    </div>
    <div className="tab-bar-end">{children}</div>
  </nav>
)

export default GameTabBar
